// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title_Title__LJHjk Title_Title__3Em2w","noTopMargin":"Title_noTopMargin__1ZpTk"};